import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';
import { registrarEvento } from './analyticsService';

// Capa de datos de la AGENDA / CITAS. Multi-tenant por negocio_id + RLS.

export async function obtenerCitas({ desde = null, hasta = null } = {}) {
  let q = supabase
    .from('citas')
    .select('*')
    .eq('negocio_id', getNegocioId())
    .order('fecha', { ascending: true })
    .order('hora', { ascending: true, nullsFirst: true });
  if (desde) q = q.gte('fecha', desde);
  if (hasta) q = q.lte('fecha', hasta);
  const { data, error } = await q;
  if (error) throw error;
  return data || [];
}

export async function crearCita(datos) {
  const { data, error } = await supabase
    .from('citas')
    .insert([{ ...datos, negocio_id: getNegocioId() }])
    .select()
    .single();
  if (error) throw error;
  registrarEvento('cita_creada', { servicio: datos.servicio_nombre || null });
  return data;
}

export async function actualizarCita(id, datos) {
  const { error } = await supabase
    .from('citas')
    .update({ ...datos, actualizado_en: new Date().toISOString() })
    .eq('id', id).eq('negocio_id', getNegocioId());
  if (error) throw error;
}

export async function cambiarEstadoCita(id, estado) {
  const { error } = await supabase
    .from('citas')
    .update({ estado, actualizado_en: new Date().toISOString() })
    .eq('id', id).eq('negocio_id', getNegocioId());
  if (error) throw error;
}

export async function eliminarCita(id) {
  const { error } = await supabase
    .from('citas').delete()
    .eq('id', id).eq('negocio_id', getNegocioId());
  if (error) throw error;
}
